<div class="modal-auth-header">Login Required</div>

<span
    id="auth-close-btn"
    class="iapply-dialog-close-wrapper modal-auth-close-button"
    mat-dialog-close
    (click)="closeModal()">
    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
</span>

<mat-divider class="modal-auth-divider"></mat-divider>

<mat-tab-group>
    <mat-tab *ngIf="allowRegister" label="Create new User">
        <!-- Sign Up -->
        <div>
            <sign-up-form (successEvent)="signUpSuccess($event)"></sign-up-form>
        </div>
    </mat-tab>

    <mat-tab label="Sign in with existing user">
        <!-- Sign In -->
        <div *ngIf="currentPage === authPageType.SignIn">
            <ng-container *ngIf="!twoFactorRequired">
                <sign-in-form
                    (successEvent)="signInSuccess($event)"
                    (forgetPasswordEvent)="redirectToForgetPassword()">
                </sign-in-form>
            </ng-container>

            <!-- Sign In With 2fa -->
            <ng-container *ngIf="twoFactorRequired">
                <div
                    *ngIf="!twoFactorActivationRequired"
                    class="modal-auth-title modal-auth-twofa-title">
                    Two-Factor Authentication
                </div>

                <twofa-instruction
                    [twoFactorActivationRequired]="twoFactorActivationRequired">
                </twofa-instruction>

                <twofa-form
                    (successEvent)="verifyTwoFaSuccess($event)"
                    (errorEvent)="goBackToSignIn(true)"
                    [twoFactorActivationRequired]="twoFactorActivationRequired">
                </twofa-form>
            </ng-container>
        </div>

        <!-- Forgot password -->
        <div *ngIf="currentPage === authPageType.ForgotPassword">
            <div class="modal-auth-title modal-auth-forgot-password-title">
                Forgot password?
            </div>
            <div class="modal-auth-subtitle modal-auth-forgot-password-subtitle">
                Provide your username/email address to reset your password
            </div>
            <forgot-password-form
                (goBackEvent)="goBackToSignIn()"></forgot-password-form>
        </div>
    </mat-tab>
</mat-tab-group>